// Routes des inspections et contrôles (lot L3-B, M23), raccordées dans Application.tsx par une seule
// ligne. Les chemins fixes précèdent les fiches.
import type { RouteObject } from 'react-router';
import { PageConstat } from './PageConstat';
import { PageFormulaires } from './PageFormulaires';
import { PageMesures } from './PageMesures';
import { PageOrdre } from './PageOrdre';
import { PageOrdres } from './PageOrdres';
import { PagePlans } from './PagePlans';

export const routesInspections: RouteObject[] = [
  { path: '/inspections', element: <PageOrdres /> },
  { path: '/inspections/plans', element: <PagePlans /> },
  { path: '/inspections/formulaires', element: <PageFormulaires /> },
  { path: '/inspections/mesures', element: <PageMesures /> },
  { path: '/inspections/ordres/:id', element: <PageOrdre /> },
  { path: '/inspections/constats/:id', element: <PageConstat /> },
];
